/* esm.sh - minimalistic-assert@1.0.1 */
export * from "/*minimalistic-assert@1.0.1/esnext/minimalistic-assert.mjs";
export { default } from "/*minimalistic-assert@1.0.1/esnext/minimalistic-assert.mjs";
